import { render, staticRenderFns } from "./inventory-detail.vue?vue&type=template&id=a7f1adc6&scoped=true&"
import script from "./inventory-detail.vue?vue&type=script&lang=js&"
export * from "./inventory-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f1adc6",
  null
  
)

export default component.exports